'use client';

import { TypingUser } from '@/types/chat';

interface TypingIndicatorProps {
    typingUsers: TypingUser[];
    currentChannelId: string | null;
}

export default function TypingIndicator({ typingUsers, currentChannelId }: TypingIndicatorProps) {
    const usersTypingInChannel = typingUsers.filter(tu => tu.channelId === currentChannelId);

    if (usersTypingInChannel.length === 0) return null;

    const getTypingText = () => {
        if (usersTypingInChannel.length === 1) {
            return `${usersTypingInChannel[0].userName} is typing`;
        } else if (usersTypingInChannel.length === 2) {
            return `${usersTypingInChannel[0].userName} and ${usersTypingInChannel[1].userName} are typing`;
        } else {
            return `${usersTypingInChannel.length} people are typing`;
        }
    };

    return (
        <div className="flex items-center gap-2 px-4 py-2 text-sm text-muted-foreground">
            <span>{getTypingText()}</span>
            <div className="flex gap-1">
                <span className="w-1.5 h-1.5 bg-muted-foreground rounded-full animate-bounce [animation-delay:-0.3s]" />
                <span className="w-1.5 h-1.5 bg-muted-foreground rounded-full animate-bounce [animation-delay:-0.15s]" />
                <span className="w-1.5 h-1.5 bg-muted-foreground rounded-full animate-bounce" />
            </div>
        </div>
    );
}
